import { useMutation, useQueryClient } from '@tanstack/react-query';
import { converters as filesConverters } from 'store/files';
import { loaders } from './claims.loaders';
import { claimsKeys } from './claims.queries';

export const useExportToXls = () => {
  return useMutation(loaders.exportXls, {
    onSuccess: filesConverters.export,
  });
};

export const useUpdateClaim = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateClaim, {
    onSuccess: () => {
      return queryClient.invalidateQueries(claimsKeys.all);
    },
  });
};

export const useUpdateClaims = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateClaims, {
    onSuccess: () => {
      return queryClient.invalidateQueries(claimsKeys.all);
    },
  });
};
